
import React from 'react';
import { LogOut, Cog, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface SidebarFooterProps {
  userName: string;
  handleSignOut: () => void;
}

const SidebarFooter = ({ userName, handleSignOut }: SidebarFooterProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="p-6 mt-auto border-t border-gray-100 dark:border-[rgba(60,63,84,0.6)]">
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={() => navigate('/dashboard/settings')}
          className="flex items-center text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
        >
          <Cog className="w-5 h-5" />
          <span className="ml-2">Paramètres</span>
        </button>
        <button
          onClick={handleSignOut}
          className="flex items-center text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
        >
          <LogOut className="w-5 h-5" />
        </button>
      </div>
      <div className="flex justify-center">
        <button
          onClick={() => navigate('/privacy')}
          className="flex items-center text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
        >
          <FileText className="w-3 h-3 mr-1" />
          <span>Règles de confidentialité</span>
        </button>
      </div>
    </div>
  );
};

export default SidebarFooter;
